import { useSiteClub } from "../lib/SiteClubContext";

/** /live -- the club's livestream players (Manage -> Streaming), plus a
 *  link out to its LiveRC page. Each player is a sandboxed iframe: scripts
 *  run (players need them) in the player's own origin, but it can't
 *  navigate this page, open forms, or touch the signed-in session. */
export default function LivePage() {
  const { club, loading } = useSiteClub();
  if (loading) return <p className="muted">Loading…</p>;

  const stream = club?.stream;
  const embeds = stream?.embeds ?? [];

  return (
    <div>
      <h1>{club ? `${club.name} live` : "Live"}</h1>
      {!club && <p className="notice">Live streams are on each club's own site.</p>}
      {club && !embeds.length && !stream?.liveRcUrl && (
        <p className="notice">{club.name} hasn't set up a live stream yet.</p>
      )}
      {stream?.liveRcUrl && (
        <p>
          <a href={stream.liveRcUrl} target="_blank" rel="noopener noreferrer">
            Watch timing and video on LiveRC
          </a>
        </p>
      )}
      {embeds.map((e) => (
        <section key={e.url} style={{ marginBottom: "1.5rem" }}>
          <h3>{e.label}</h3>
          <div className="stream-embed">
            <iframe
              src={e.url}
              title={e.label}
              loading="lazy"
              sandbox="allow-scripts allow-same-origin allow-presentation allow-popups"
              allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </section>
      ))}
    </div>
  );
}
